// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".a-media__wrapper[data-v-2fee7bfb]{width:100%}.image-caption[data-v-2fee7bfb]{margin-top:10px}", ""]);
// Exports
module.exports = exports;
